export const LOAD_INIT = 'provider/LOAD_INIT';
export const LOAD_SUCCESS = 'provider/LOAD_SUCCESS';
export const LOAD_FAIL = 'provider/LOAD_FAIL';

const ENDPOINT = '/api/coverage';

const initialState = {
  payload: {},
  providers: {}
};

export default function coverage(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      payload
    };
  }

  return state;
}

export function getCoveragByProvider(addressId, provider) {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/${addressId}${provider ? `/${provider}`: ''}`)
  };
}
